import React from 'react';
import { SolutionsIntro } from '../components/solutions/SolutionsIntro';
import { EmbeddedSolution } from '../components/solutions/EmbeddedSolution';
import { SolutionsCycle } from '../components/solutions/SolutionsCycle';
export function SolutionsPage() {
  return <>
      <SolutionsIntro data-id="element-3497" data-mp="12jvcyv5wujdy" />
      <EmbeddedSolution id="research" anchor="scientific-research" data-id="element-3498" data-mp="12k56gsq5z8oe" />
      <EmbeddedSolution id="clinical" anchor="clinical" data-id="element-3499" data-mp="4w4u207igq2g" />
      <SolutionsCycle data-id="element-3500" data-mp="4xg066ofi9wq" />
    </>;
}